module.exports = __webpack_public_path__ + "static/img/lzbank.75479d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/lzbank.png
// module id = BPff
// module chunks = 93